export default "__VITE_ASSET__BWScjJyP__"